





















import {mixins} from "vue-class-component";
import {Component, Prop} from "vue-property-decorator";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
    name: "CardStatistic"
})
export default class extends mixins(CommonMixin) {
    @Prop() data!: any;
    @Prop() icon!: any;
}
